export interface AuthenticateOptions {
    redirect?: string;
    flow?: AuthFlow;
}

export enum AuthFlow {
    Checkout = 'checkout',
}
